module.exports = __webpack_public_path__ + "img/introducePageFour_show_four.667f8294.jpg";